import { render, staticRenderFns } from "./FundTransferTableRow.vue?vue&type=template&id=313a4e86&"
import script from "./FundTransferTableRow.vue?vue&type=script&lang=js&"
export * from "./FundTransferTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports